import { FullPolicyData } from 'interfaces/customerDataTypes';

export const shouldAllowCardUpdate = (selectedPolicy?: FullPolicyData): boolean => {
  return !!(selectedPolicy && selectedPolicy.cardNumber && selectedPolicy.cardExpiry && selectedPolicy.braintreeId);
};
